// extracted by mini-css-extract-plugin
module.exports = {"postnordDisclaimer":"DeliveryAddressMap_postnordDisclaimer__LiaQU"};